module.exports = __webpack_public_path__ + "img/idlefish-logo.66786b60.png";